import {
  Component,
  ElementRef,
  HostBinding,
  inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import {
  NavigationLayoutSettingStore,
  ToggleNavigationOpen,
} from '../../../stores/app/navbar.state';
import { SideMenuStore } from '../../../stores/app/side-menu.state';
import { AppThemeStore } from '../../../stores/app/theme.state';

import { NkModule } from '../../../shared/nk.module';
import { NkSharedModule } from '../../../shared/shared.module';
import { NkContentModule } from './content/content.module';
import { NkFooterModule } from './footer/footer.module';
import { NkNavbarModule } from './navbar/navbar.module';
import { NkQuickPanelModule } from './quick-panel/quick-panel.module';
import { NkToolbarModule } from './toolbar/toolbar.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import {
  NkNavigationModule,
  NkSearchBarModule,
  NkShortcutsModule,
  NkSidebarModule,
  NkThemeOptionsModule,
} from '../../../components';
import { NkSidebarComponent } from '../../../components/sidebar/sidebar.component';
import { NkMatSidenavHelperService } from '../../../services/app-services/sidenav.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports:[
    MatSidenavModule,
    NkContentModule,
    NkFooterModule,
    NkNavbarModule,
    NkNavigationModule,
    NkQuickPanelModule,
    NkSearchBarModule,
    NkSharedModule,
    NkShortcutsModule,
    NkSidebarModule,
    NkThemeOptionsModule,
    NkToolbarModule,
    RouterModule,
    NkSidebarComponent
  ]
})
export class NkMainComponent implements OnInit, OnDestroy {
  @HostBinding('attr.nk-layout-mode') public layoutMode: any;

  public sideBarConfig: any;
  public nkSettings: any;
  public navigation: any;

  private appThemeConfig$: Observable<any> = inject(Store).select(AppThemeStore.appThemeConfig);

  private sideBarConfig$: Observable<any> = inject(Store).select(NavigationLayoutSettingStore.navLayoutConfig);

  public navMenu$: Observable<any> = inject(Store).select(SideMenuStore.navMenu);

  private onConfigChangedSubscription!: Subscription;
  private onSideBarConfigChangedSubscription!: Subscription;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly store: Store,
     private readonly nkMatSidenavService: NkMatSidenavHelperService,
  ) {}

  public ngOnInit() {
    
    this.onConfigChangedSubscription = this.appThemeConfig$.subscribe(
      (newSettings) => {
      
        this.nkSettings = newSettings;
        this.layoutMode = this.nkSettings.layout.mode;
      }
    );

    this.onSideBarConfigChangedSubscription = this.sideBarConfig$.subscribe(
      (v) => {
     
        this.sideBarConfig = v
      }
        
    );
    // this.navigation = navigation;
  }

  public ngOnDestroy() {
    this.onConfigChangedSubscription?.unsubscribe();
    this.onSideBarConfigChangedSubscription?.unsubscribe();
  }

  private addClass(className: string) {
    this.renderer.addClass(this.elementRef.nativeElement, className);
  }

  private removeClass(className: string) {
    this.renderer.removeClass(this.elementRef.nativeElement, className);
  }

  public navbarBackDropClicked() {
    this.store.dispatch(new ToggleNavigationOpen());
  }
  public openQuickPanel() {
  const sidenav = this.nkMatSidenavService.getSidenav('quick-panel');
  sidenav?.open();
  this.addClass('show-quick-panel-backdrop');
}
public onBackdropClick() {
 
  const sidenav = this.nkMatSidenavService.getSidenav('quick-panel');
  sidenav?.close();
  this.removeClass('show-quick-panel-backdrop');
}
public logBackdropClick() {
 
}
}
